module.exports = __webpack_public_path__ + "img/Inflammation-CRC_CRLM.dec736a0.png";